import { useState } from "react";
import { Link, useNavigate, Navigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { useAdminAuth } from "../context/AdminAuthContext";

export default function AdminLoginPage() {
  const { admin, login } = useAdminAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (admin) return <Navigate to="/admin" replace />;
  if (admin === undefined)
    return (
      <div className="min-h-screen bg-[#090909] flex items-center justify-center text-[#A1A1AA] font-sans">
        …
      </div>
    );

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    const res = await login(email, password);
    setSubmitting(false);
    if (res.ok) navigate("/admin");
    else setError(res.error);
  };

  return (
    <div
      className="min-h-screen bg-[#090909] flex items-center justify-center px-6 relative"
      data-testid="admin-login-page"
    >
      <Link
        to="/"
        data-testid="admin-back-link"
        className="absolute top-8 left-8 inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.35em] font-sans font-light text-[#A1A1AA] hover:text-[#D4AF37] transition-colors group"
      >
        <ArrowLeft
          size={14}
          strokeWidth={1.4}
          className="group-hover:-translate-x-1 transition-transform"
        />
        Zur Website
      </Link>

      <motion.form
        onSubmit={submit}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        className="w-full max-w-md border border-[#D4AF37]/20 bg-[#0b0b0b] p-8 md:p-10 space-y-6"
        data-testid="admin-login-form"
      >
        <div>
          <span className="gold-divider">Nur für Nicole</span>
          <h1 className="font-serif font-light text-3xl text-[#E5E5E5] mt-6">
            Atelier <span className="italic gold-text">Login</span>
          </h1>
        </div>

        <label className="block">
          <span className="text-[10px] uppercase tracking-[0.35em] text-[#A1A1AA] font-sans">
            E-Mail
          </span>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            data-testid="admin-login-email"
            className="mt-2 w-full bg-transparent border border-[#D4AF37]/20 px-3 py-3 font-sans text-sm text-[#E5E5E5] focus:outline-none focus:border-[#D4AF37]/60"
          />
        </label>

        <label className="block">
          <span className="text-[10px] uppercase tracking-[0.35em] text-[#A1A1AA] font-sans">
            Passwort
          </span>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            data-testid="admin-login-password"
            className="mt-2 w-full bg-transparent border border-[#D4AF37]/20 px-3 py-3 font-sans text-sm text-[#E5E5E5] focus:outline-none focus:border-[#D4AF37]/60"
          />
        </label>

        {error && (
          <p className="text-sm text-red-400 font-sans" data-testid="admin-login-error">
            {error}
          </p>
        )}

        <button
          type="submit"
          disabled={submitting}
          data-testid="admin-login-submit"
          className="btn-gold w-full px-8 py-3 font-sans font-light tracking-widest text-xs uppercase disabled:opacity-40"
        >
          {submitting ? "Anmeldung…" : "Anmelden"}
        </button>
      </motion.form>
    </div>
  );
}
